export default __webpack_public_path__ + "static/media/purplelab_audiences_dtc_semcast_1_.a2359f70.pdf";